import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@app/core/services/auth.service';
import { primengImports } from '@app/core/primeng';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-reinitialiser',
  imports: [CommonModule, ReactiveFormsModule, ButtonModule, ...primengImports],
  templateUrl: './reinitialiser.component.html',
  styleUrl: './reinitialiser.component.scss'
})
export class ReinitialiserComponent {
  form: FormGroup;
  submitted = false;
  token = '';
  successMessage = '';
  errorMessage = '';

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    public authService: AuthService
  ) {
    this.form = this.fb.group(
      {
        password: ['', [Validators.required, Validators.minLength(8)]],
        confirmPassword: ['', [Validators.required]]
      },
      { validators: [this.passwordsMatchValidator] }
    );
  }

  ngOnInit() {
    this.token = this.route.snapshot.paramMap.get('token') ?? '';
  }

  get f() {
    return this.form.controls;
  }

  passwordsMatchValidator(group: FormGroup) {
    const p = group.get('password')?.value;
    const c = group.get('confirmPassword')?.value;
    return p && c && p === c ? null : { passwordMismatch: true };
  }

  onSubmit() {
    this.submitted = true;
    this.successMessage = '';
    this.errorMessage = '';

    if (!this.token) {
      this.errorMessage = 'Lien de réinitialisation invalide ou expiré.';
      return;
    }

    if (this.form.invalid) return;

    this.authService.resetPasswordWithToken(this.token, this.form.value.password).subscribe({
      next: () => {
        this.successMessage = 'Mot de passe mis à jour. Vous pouvez maintenant vous connecter.';
      },
      error: () => {
        this.errorMessage = "Impossible de réinitialiser le mot de passe. Veuillez réessayer.";
      }
    });
  }

  onSignIn() {
    this.router.navigate(['login']);
  }
}

